<template>
    <div class="px-1">
        <span class="badge bg-blue" style="width: 35px;">{{amount}}</span>
    </div>
</template>

<script>
export default {
    name:"CustomBadge",
    props: {
        amount: {
            type: Number,
            required: true
        }
    }
}
</script>

<style lang="css" scoped>
    @import"../../assets/css/_colors";
</style>
